import React, { useState } from "react";
import IconArrowDown from "@/app/(components)/generics/Icons/IconArrowDown";
import IconArrowRight from "@/app/(components)/generics/Icons/IconArrowRight";
import IconArrowUp from "@/app/(components)/generics/Icons/IconArrowUp";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Collapsible.module.css";

type Props = {
  isOpen?: boolean;
  treeMode?: boolean;
  withArrowIcon?: boolean;
  onToggle?: (isOpen: boolean) => void;
  trigger?: React.ReactNode;
  content?: React.ReactNode;
  containerClassName?: string;
};

export default function Collapsible(props: Props) {
  const {
    isOpen: initialIsOpen = false,
    treeMode = false,
    withArrowIcon = true,
    onToggle = () => {},
    trigger,
    content,
    containerClassName,
  } = props;

  const [isOpen, setIsOpen] = useState(initialIsOpen);

  React.useEffect(() => {
    setIsOpen(initialIsOpen);
  }, [initialIsOpen]);

  const toggle = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    onToggle(newIsOpen);
  };

  return (
    <div className={UStyles.classNames(styles.container, containerClassName)}>
      <div
        className={`${styles.trigger} ${treeMode ? styles.triggerTree : styles.triggerDefault}`}
        onClick={toggle}
        role="none"
      >
        {treeMode && (
          <span className={isOpen ? styles.toggleBtnMax : styles.toggleBtn}>
            {isOpen ? <IconArrowDown /> : <IconArrowRight />}
          </span>
        )}

        {trigger}

        {!treeMode && withArrowIcon && (
          <span className={styles.toggleBtn}>{isOpen ? <IconArrowUp /> : <IconArrowDown />}</span>
        )}
      </div>

      <div className={`${styles.content} ${isOpen ? styles.open : ""}`}>{content}</div>
    </div>
  );
}
